export const ACCOUNT_GROUP_RESPONSIBLE_IMAGE_SRC = 'https://www.sunweb.nl/-/media/sundio/account/my-account-header-groups.ashx'
export const ACCOUNT_BOOKING_DEFAULT_IMAGE_SRC = 'https://www.sunweb.nl/-/media/sundio/account/my-account-header.ashx'
export const NO_UPCOMING_BOOKING_IMAGE_SRC = {
  sun: '/-/media/sundio/account/no-upcoming-booking-sun.ashx',
  ski: '/-/media/sundio/account/no-upcoming-booking-ski.ashx',
  eliza: '/-/media/sundio/account/no-upcoming-booking-eliza.ashx',
}
